(function()
{
	//Import classes
	var BaseState = include('springroll.easeljs.BaseState'),
		GamePanel = include('WGBH.GamePanel'),
		AccButtonToggle = include('WGBH.AccButtonToggle'),
		FishManager = include('WGBH.FishManager'),
		ButtonsManager = include('WGBH.ButtonsManager');

	/**
	 * The logic for the title state
	 * @class WGBH.TitleState
	 * @extends springroll.easeljs.BaseState
	 */
	var GameState = function(options)
	{
		BaseState.call(this, new GamePanel(), options);
		
		// set up function binding
		this.buttonActivation = this.buttonActivation.bind(this);
		this.startAnswerOptions = this.startAnswerOptions.bind(this);
		this.setAnswer = this.setAnswer.bind(this);
		this.checkAnswer = this.checkAnswer.bind(this);
		this.allowTryAgain = this.allowTryAgain.bind(this);
		this.playLevelComplete = this.playLevelComplete.bind(this);
		
	};

	//Extend the base state
	var p = extend(GameState, BaseState);

	/**
	 * After assets are loaded and state is fully entered
	 * @method  enterDone
	 */
	p.enterDone = function()
	{
		app.caption_disp.className = 'on';			
		app.acc_mgr.setCaptionParameters('captions', app.config.GAME.CAPTIONS.game);
	
		// parameters
		app.correct_answer = '';
		this.answer_picked = '';
		this.num_guesses = 0;
		this.inc_resp = app.config.GAME.RESPONSES.incorrect.slice(0);
		
		// set up display
		this.animdisp = this.panel.animdisp;
        this.uidisp = this.panel.uidisp;  
		
        // build school of fish
        this.fishmgr = new FishManager();
        this.animdisp.addChild(this.fishmgr.view);
        
        // start level 
        this.setNewLevel();
	};
	
	// used to react to button clicks
	p.buttonActivation = function(ev) {
//console.log('BUTTON ACTIVATED: ' + ev.id);
		switch(ev.id) {
		case 'musicbt_on':
			app.playBackgroundMusic();
			break;
		case 'musicbt_off':
			app.stopBackgroundMusic();
			break;		
		case 'captbt_on':			
			app.caption_disp.className = 'on raised';
			app.capt_on = true;	
            window.parent.postMessage('captions on', '*');			
			break;
		case 'captbt_off':
			app.caption_disp.className = 'off';
			app.capt_on = false;	
            window.parent.postMessage('captions off', '*');			
			break;		
		}	
	};
	
	// used to start a new round
	p.setNewLevel = function() {
		var mycolors = [],
			ctr = 0, 
			max = app.config.GAME.FISH.seq.max;
		// depending on the level, do one of a few things.
		switch (app.level_num) {
		case 1 :
// LEVEL ONE: Pick a color at random, all fish get that color. (AAAAAAAA)
			mycolors = this.getcolor(1, []);
			for (; ctr < max; ctr++) {
				this.fishmgr.fishes.push({'clr':mycolors[0]});
			}
			break;
		case 2 :
// LEVEL TWO: Pick two colors at random, alternate back and forth (ABABABAB)
			mycolors = this.getcolor(2, []);
			for (; ctr < max; ++ctr) {
				if (ctr % 2 === 0) {
					this.fishmgr.fishes.push({'clr':mycolors[0]});
				} else {
					this.fishmgr.fishes.push({'clr':mycolors[1]});
				}
			}
			break;
		case 3 :
// LEVEL THREE: Pick two colors at random, alternate doubled (AABBAABB)
			mycolors = this.getcolor(2, []);
			for (; ctr < max; ++ctr) {
				if (ctr % 4 === 0 || (ctr - 1) % 4 === 0) {
					this.fishmgr.fishes.push({'clr':mycolors[0]});
				} else {
					this.fishmgr.fishes.push({'clr':mycolors[1]});
				}
			}
			break;
		case 4 :
// LEVEL FOUR: Pick two colors at random, alternate quadrupled (AAAABBBB)
			mycolors = this.getcolor(2, []);
			for (; ctr < max; ++ctr) {
				if (ctr < 4) {
					this.fishmgr.fishes.push({'clr':mycolors[0]});
				} else {
					this.fishmgr.fishes.push({'clr':mycolors[1]});
				}
			}
			break;
		case 5 :
// LEVEL FIVE: Pick three colors at random, alternate (ABCABCAB)
			mycolors = this.getcolor(3, []);
			for (; ctr < max; ++ctr) {
				if (ctr % 3 === 0) {
					this.fishmgr.fishes.push({'clr':mycolors[0]});
				} else if ((ctr + 1) % 3 === 0) {
					this.fishmgr.fishes.push({'clr':mycolors[1]});
				} else {
					this.fishmgr.fishes.push({'clr':mycolors[2]});
				}
			}
			break;
		case 6 :
// LEVEL SIX: Pick two colors at random, triple then single (AAABAAAB)
			mycolors = this.getcolor(2, []);
			for (; ctr < max; ++ctr) {
				if (ctr === 3 || ctr === 7) {
					this.fishmgr.fishes.push({'clr':mycolors[0]});
				} else {
					this.fishmgr.fishes.push({'clr':mycolors[1]});
				}
			}
			break;
		case 7 :
// LEVEL SEVEN: Pick three colors at random, double then two singles (AABCAABC)
			mycolors = this.getcolor(3, []);
			for (; ctr < max; ++ctr) {
				if ((ctr) % 4 === 0 || (ctr - 1) % 4 === 0) {
					this.fishmgr.fishes.push({'clr':mycolors[0]});
				} else if ((ctr - 2) % 4 === 0) {
					this.fishmgr.fishes.push({'clr':mycolors[1]});
				} else {
					this.fishmgr.fishes.push({'clr':mycolors[2]});
				}
			}
			break;
		default:
			break;
		}
		app.correct_answer = this.fishmgr.fishes[max - 1].clr;
		this.fishmgr.fishes[max - 1].clr = 'white';
		this.fishmgr.init();
		this.fishmgr.ans_fish.ev_disp.on('ANSWER_DISPLAYED', this.checkAnswer);
		// set up buttons
		this.setButtons();
		// check if first round intro should be played
		if(app.level_num === 1) {
			app.voPlayer.play(['pause', 'intro1'], this.startAnswerOptions);		
		}
		else {
			// start regular round
			this.startAnswerOptions();
		}
	};
	
	// used to gather what colors will be used for the round
	p.getcolor = function(howmany, skipcolors) {
		// return an array of colors chosen at random, depending on how many I just asked for.
		// if skipcolors is set, DON'T choose those colors. Should it be an array?
		var usecolors = [],
			sendcolors = [],
			thiscolor = '',
			skipcolor = '',
			pick = '',
			i = 0;
		usecolors = usecolors.concat(app.config.GAME.FISH.types);
		if (skipcolors.length > 0) {
			for (var ski in usecolors) {
				thiscolor = usecolors[ski];
				for (var skip in skipcolors) {
					skipcolor = skipcolors[skip];
					if (thiscolor == skipcolor) {
						usecolors.splice(ski, 1);
					}
				}
			}
		}
		for (; i < howmany; ++i) {
			pick = Math.floor(Math.random() * usecolors.length);
			thiscolor = usecolors[pick];
			usecolors.splice(pick, 1);
			sendcolors.push(thiscolor);
		}
		return sendcolors;
	};
	
	// used to set the game buttons
	p.setButtons = function() {
		// one of the buttons gets the correct color, the other two get other colors (at random?)
		var skpclrs = [app.correct_answer],
			colarray = this.getcolor(2, skpclrs),
			pick = Math.floor(Math.random() * 3);
		// insert the correct answer color
		colarray.splice(pick, 0, app.correct_answer);	
		this.btns_mgr = new ButtonsManager(colarray);
		this.btns_mgr.ev_disp.on('ANSWER_SELECTED', this.setAnswer);
		this.uidisp.addChild(this.btns_mgr.view);
		// add control buttons
		this.captbt = new AccButtonToggle(
						'captbt',
        				LOADED_OBJECTS.sprsheets.graphics_spr,
        				app.config.GAME.BUTTONS.captbt.x,
        				app.config.GAME.BUTTONS.captbt.y, 
        				app.config.GAME.BUTTONS.captbt.wid, 
        				app.config.GAME.BUTTONS.captbt.hgt,
        				app.config.GAME.BUTTONS.captbt.label,
        				app.capt_on
        				);
		app.acc_mgr.addInteractiveButton(this.captbt);
		this.captbt.ev_disp.on('BUTTON_DOWN', this.buttonActivation);
		this.uidisp.addChild(this.captbt.view);
		
		// set status of captions
		if(app.capt_on) {
			this.buttonActivation({'id':'captbt_on'});
		}
		else {
			this.buttonActivation({'id':'captbt_off'});
		}

		this.musicbt = new AccButtonToggle(
						'musicbt',
        				LOADED_OBJECTS.sprsheets.graphics_spr,
        				app.config.GAME.BUTTONS.musicbt.x,
        				app.config.GAME.BUTTONS.musicbt.y, 
        				app.config.GAME.BUTTONS.musicbt.wid, 
        				app.config.GAME.BUTTONS.musicbt.hgt,
        				app.config.GAME.BUTTONS.musicbt.label,
        				app.bg_music_on 
        				);
		app.acc_mgr.addInteractiveButton(this.musicbt);
		this.musicbt.ev_disp.on('BUTTON_DOWN', this.buttonActivation);
        this.uidisp.addChild(this.musicbt.view);
	};
	
	// used to start the answer options
	p.startAnswerOptions = function() {
		this.btns_mgr.startButtonDisplay();	
	};
	
	// used to set the answer
	p.setAnswer = function(ev) {
		this.answer_picked = ev.clr;
		this.fishmgr.displayAnswer(this.answer_picked);
	};
	
	// used to check the answer
	p.checkAnswer = function() {
		++this.num_guesses;
		if(app.correct_answer === this.answer_picked) {
			if (this.num_guesses === 1) {
				++app.level_num;
				if (app.level_num > 7) {
					app.level_num = 1;
				}
			}
			if(app.correct_resp.length === 0) {
				app.correct_resp = app.config.GAME.RESPONSES.correct.slice(0);
			}
			app.voPlayer.play(['pause', app.correct_resp.shift(), 'pause'], this.playLevelComplete);	
		}
		else {
			app.voPlayer.play(['pause', this.inc_resp.shift(), 'pause'], this.allowTryAgain);	
			if(this.inc_resp.length === 0) {
				this.inc_resp = app.config.GAME.RESPONSES.incorrect.slice(0);
			}
		}
	};
	
	// used to set the buttons to try again
	p.allowTryAgain = function() {
		this.fishmgr.resetAnswer();
		this.btns_mgr.enableButtons();	
	};
	
	// used to trigger the success screen when level is complete
	p.playLevelComplete = function() {
		this.nextState();
	};

	/**
	 * When the state starts to exit, before transition
	 * @method  exitStart
	 */
	p.exitStart = function()
	{
		app.acc_mgr.removeButtonsFromDOM();	
		app.acc_mgr.clearSRContent();	
		// remove things from the display
		while(this.animdisp.numChildren > 0) {
			this.animdisp.removeChildAt(0);
		}
		while(this.uidisp.numChildren > 0) {
			this.uidisp.removeChildAt(0);
		}
		this.musicbt.clearObject();
		this.captbt.clearObject();
		this.fishmgr.clearObject();
		this.btns_mgr.clearObject();
		this.musicbt = null;
		this.captbt = null;
		this.fishmgr = null;
		this.btns_mgr = null;
	};

	//Assign to namespace
	namespace('WGBH').GameState = GameState;
}());